/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart/payment';
const RESOURCE_PAGE_ACTION = '/klarna/session';

/**
 * getKlarnaClientToken
 * url - /checkout/{apiversion}/cart/payment/{cartId}/klarna/session
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 */

const getKlarnaClientToken = ({
    env, jwtToken, cartId,
}) => {
    const envObj = env || {};
    envObj.rootUri = RESOURCE_ROOT_CARTSERVICE;

    const resourcePage = `${RESOURCE_VERSION_CARTSERVICE}${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}`;

    return restClient.getRequest(envObj, resourcePage, jwtToken)
        .then((response) => response);
};

export default getKlarnaClientToken;
